import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import CheckCircle from '@mui/icons-material/TaskAlt';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
const bannerSteps = [
    {
        icon: <SportsEsportsIcon fontSize="inherit"/>,
        text: 'Find Games to Play on Stream',
    },
    {
        icon: <CheckCircle fontSize="inherit"/>,
        text: 'Accept Dares for Your Key',
    },
    {
        icon: <VpnKeyIcon fontSize="inherit"/>,
        text: 'Deliver and Giveaway Keys',
    },
];
export const DropsBanner = () => {
    return (<div className="flex flex-col gap-10 justify-center">
			<div className="flex flex-col gap-4">
				<h1 className="text-3xl font-bold text-center">Key Drops</h1>
				<h2 className="sm:text-xl text-center">Earn Keys for your Fans by Completing Dares for these Games</h2>
			</div>
			<div className="flex justify-between items-center gap-8">
				{bannerSteps.map(({ icon: Icon, text }) => (<div key={text} className="flex flex-col justify-center items-center">
						<div className="text-5xl md:text-7xl">
							{Icon}
						</div>
						<span className="text-sm text-center">{text}</span>
					</div>))}
			</div>
		</div>);
};
